import { IRefund } from '../../../shared/interfaces/refund/IRefund';
import { IBaseModel } from '../../../shared/interfaces/shared/IBase';
import { IPagination } from '../../../shared/interfaces/shared/IPagination';
import { formDataHeaders, requests } from '../../../utils/api/api.service';
import { REFUND_URL } from '../../../utils/api/endpoints';

export const AdminRefundService = {
  get: (params: IPagination): Promise<IBaseModel<IRefund[]>> =>
    requests.get(REFUND_URL, params),
  getSingle: (id: number): Promise<IRefund> =>
    requests.get(`${REFUND_URL}/${id}`),
  create: (payload: FormData): Promise<IRefund> =>
    requests.post(REFUND_URL, payload, formDataHeaders),
  update: (payload: FormData, id: number): Promise<IRefund> =>
    requests.put(`${REFUND_URL}/${id}`, payload, formDataHeaders),
  delete: (id: number): Promise<IRefund> =>
    requests.delete(`${REFUND_URL}/${id}`),
};
